module.exports = __webpack_public_path__ + "static/media/12.418c6c79.webp";